import {
  Address,
  LoyaltyDiscountType,
  LoyaltyRewardStatus,
  OrderStatus,
  Product,
} from '@onbeefapp/constants';
import { LoginResponse } from '../login/types';

export interface LoyaltySubscriptionPayload {
  loyalty_programme_id: string;
  customer_id?: string;
  name?: string;
  phone?: string;
  taxpayer_id_number?: string;
  birthday?: string;
  email?: string;
  gender?: string;
  password?: string;
  password_confirmation?: string;
  token?: string;
}

export interface LoyaltySubscriptionResponse {
  message: string;
  data: {
    auth?: LoginResponse;
    has_complete_registration?: boolean;
  };
}

export interface LoyaltyProgramme {
  id: string;
  name: string;
  merchant_id: string;
  coin_id: string;
  status: string;
  messages: string[];
  reward: {
    id: string;
    loyalty_programme_id: string;
    type: string;
    quantity_order: number;
    total_balance_amount: number | null;
    discount: LoyaltyDiscount | null;
    product: Product | null;
    customer_quantity_order: number;
    customer_balance_amount: number;
    points_per_currency: string | null;
    points_expired_days_at: number | null;
    customer_points: {
      available: number;
      pending: number;
      spent: number;
      next_expiration_formatted: string | null;
    } | null;
    point_rewards: LoyaltyPointReward[];
    redemption: LoyaltyRedemption;
  };
  gift: {
    id: string;
    message: string;
    loyalty_programme_id: string;
    type: 'GIFT';
    quantity_order: number | null;
    total_balance_amount: number | null;
    discount: LoyaltyDiscount | null;
    created_at: string;
    updated_at: string;
    product: Product | null;
    redemption: LoyaltyRedemption;
  };
  customer_loyalty_programme_id: string;
  start_at: string;
}

export interface LoyaltyPointReward {
  id: string;
  product_id: string;
  file_url: string | null;
  name: string;
  quantity: number;
  quantity_points: number;
}

export interface LoyaltyRedemption {
  status:
    | LoyaltyRewardStatus.PENDING
    | LoyaltyRewardStatus.TO_RESCUE
    | LoyaltyRewardStatus.RESCUED;
  percentage: number;
  message: string;
}

export interface LoyaltyDiscount {
  type:
    | LoyaltyDiscountType.PERCENTAGE
    | LoyaltyDiscountType.AMOUNT
    | LoyaltyDiscountType.DELIVERY_FREE;
  value: number;
}

export interface Customer {
  id: string;
  name: string;
  taxpayer_id_number: string;
  email: string;
  birthday: string;
  phone: string;
  address: Address;
}

export interface CustomerPointsHistoryResponse {
  data: LoyaltyPointHistory[];
  current_page: number;
  last_page: number;
  total: number;
  per_page: number;
  from: number;
  to: number;
}

export interface LoyaltyPointHistory {
  id: string;
  amount_points: number;
  event_type: LoyaltyPointHistoryEventType;
  created_at: string;
  status: LoyaltyPointHistoryStatus;
  order: {
    id: string;
    code: string;
    balance_amount: string;
    status: OrderStatus;
    loyalty_programme_reward_discount: {
      POINTS: {
        rewards: {
          type: string;
          name: string;
        }[];
      };
      type: string;
    };
  } | null;
}

export enum LoyaltyPointHistoryStatus {
  PENDING = 'PENDING',
  EXPIRED = 'EXPIRED',
  CANCELED = 'CANCELED',
  VALID = 'VALID',
}

export enum LoyaltyPointHistoryEventType {
  EARNED = 'EARNED',
  SPENT = 'SPENT',
}
